import { render } from "./ComplianceDocs.vue?vue&type=template&id=fb3f23e4&scoped=true"
import script from "./ComplianceDocs.vue?vue&type=script&lang=js"
export * from "./ComplianceDocs.vue?vue&type=script&lang=js"

import "./ComplianceDocs.vue?vue&type=style&index=0&id=fb3f23e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3f23e4"]])

export default __exports__